import React from 'react';
import styled from "styled-components";

const Line = styled.hr`
  margin: 1rem;
  border: 0;
  border: 1px solid #d5d5d5;
  opacity: 1;
`;

const VacantesInteresar = () => {
    return (
        <div className="row ml-5 mt-4">
            <div className="col-md-12">
                <div className="boxWhiteLarge">
                    <div className="text-center mt-4">
                        <p className="h1T p-4">Vacantes que te podrían interesar</p>
                        <Line />
                        
                        <Line />
                        <div clasName="row" style={{marginBottom:"1.5rem"}}>
                            <a href="./" className="link2T">Ver más</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VacantesInteresar;